import React, { useEffect, useState, useCallback, Fragment, createRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import StyledAccessoryBuyButton from '../AccessoryBuyButton';
import { catchError} from '../../Actions/Error.action';
import { receive, loadError } from '../../Actions/Cart.action';
import { add as addToCartService } from '../../Services/Cart.service';
import { setIncludeVat } from '../../Actions/Checkout.action';

const AccessoryProductCard = (props) => {

    const item = props;
    const cart = useSelector((state) => state.cart);
    var dispatch = useDispatch();
    const [isActive, setIsActive] = useState(false);
    const onClick = async ({ articleNumber = item.id, quantityFieldId = item.quantityFieldId, packageQuantity=item.packageQuantity }) => {

        try {
            let quantity = 1;

            if(!quantityFieldId){
                quantity = quantity * packageQuantity;
            }
            const cart = await addToCartService({ articleNumber, quantity });
            dispatch(receive(cart));
            setIsActive(current => !current);
            setTimeout(() => setIsActive(current => !current), 3000);
            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };
    const regex = /(<([^>]+)>)/ig;
    const decodedDescription = item.shortDescription.replace(regex, '');
    const priceToShow = item.price.campaignPrice
        ? item.price.formattedCampaignPrice
        : item.productPrice;

    const priceStyle = item.price.formattedCampaignPrice
        ? "campaign-price"
        : "";
    return (
        <Fragment>
            <div className="small-12 large-12 columns">
                <div className="accessory-product-card">
                    <div className="accessory-product-card__left">
                        <div className="accessory-product-card__image-wrapper">
                            <a href={item.url}>
                            <img src={item.accessoryImageUrl} />
                            </a>
                        </div>
                        <div className="accessory-product-card__info">
                            <div className='accessory-product-card__info-name'><a href={item.url}><b>{item.name}</b></a></div>
                            <div className='accessory-product-card__info-description' dangerouslySetInnerHTML={{__html: decodedDescription}}></div>
                            <div className={"accessory-product-card__info-price " + priceStyle} ><b>{priceToShow}</b> <span>{cart.includeVat ? translate('product.inclvat') : translate('product.exclvat')}</span></div>
                        </div>
                    </div>
                    <div className="accessory-product-card__button">
                        <button
                            onClick={onClick}
                            className={isActive ? "accessory-buy-button--style" : "accessory-buy-button"}
                            type='button'
                        >
                            {isActive ? translate('accessory.added') : translate('accessory.add')}

                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default AccessoryProductCard